import React, { useEffect, useState } from 'react';

export const MyNetwork = () => {
  const [sales,   setSales]   = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');
 
  useEffect(() => {
    import('./resellerapi').then(({ networkAPI }) => {
      Promise.all([networkAPI.getSalesHistory(), networkAPI.getSummary()])
        .then(([s, sum]) => { setSales(s.data || []); setSummary(sum.data); })
        .catch(e => setError(e.message))
        .finally(() => setLoading(false));
    });
  }, []);
 
  const statusClass = (status) => {
    const map = { Delivered: 'delivered', Shipped: 'shipped', 'In Transit': 'transit', Pending: 'pending' };
    return `status-badge ${map[status] || 'pending'}`;
  };
 
  return (
    <div>
      {error && <div className="res-error">{error}</div>}
 
      <div className="network-summary-row">
        {[
          { label: 'Active Referrals',    key: 'active_referrals',    format: '' },
          { label: 'Pending Commission',  key: 'pending_commission',  format: '₹' },
          { label: 'Commission This Month', key: 'monthly_commission', format: '₹' },
        ].map(({ label, key, format }) => (
          <div key={key} className="net-mini-card">
            <div className="net-mini-label">{label}</div>
            <div className="net-mini-val">
              {loading ? <span className="skeleton" style={{ width: 80, height: 22, display: 'inline-block' }} /> :
                `${format}${Number(summary?.[key] || 0).toLocaleString('en-IN')}`}
            </div>
          </div>
        ))}
      </div>
 
      <div className="res-card">
        <div className="res-card-title">Your Referral Sales</div>
        {loading ? (
          <div className="skeleton" style={{ height: 200 }} />
        ) : (
          <div className="res-table-wrap">
            <table className="res-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Product</th>
                  <th>Date</th>
                  <th>Order Value</th>
                  <th>Your Commission</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {sales.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-3)' }}>
                      No referral sales yet. Share your product links to get started!
                    </td>
                  </tr>
                ) : sales.map(s => (
                  <tr key={s.id}>
                    <td className="td-primary">#{s.order_ref}</td>
                    <td>{s.customer_name}</td>
                    <td>{s.product_name}</td>
                    <td style={{ color: 'var(--text-3)', fontSize: 12 }}>{new Date(s.created_at).toLocaleDateString('en-IN')}</td>
                    <td>₹{Number(s.order_value).toLocaleString('en-IN')}</td>
                    <td className="td-green">₹{Number(s.commission).toLocaleString('en-IN')}</td>
                    <td><span className={statusClass(s.status)}>{s.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};


export default MyNetwork;